import type { CustomIconProps } from '../types';

const Shipping = ({ width, height }: CustomIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '12'}
        height={height ?? '12'}
        viewBox="0 0 12 12"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.1274 0.0225775C6.04508 -0.00752582 5.95486 -0.00752582 5.87254 0.0225775L3.5778 0.861776C3.56963 0.864446 3.56157 0.867396 3.55362 0.870619L0.753623 1.89459C0.690658 1.91595 0.635221 1.95376 0.592364 2.00293C0.534857 2.06892 0.5 2.15536 0.5 2.25V9.54167C0.5 9.69453 0.592262 9.83209 0.733192 9.88936L5.85841 11.9719C5.94052 12.0058 6.03266 12.0094 6.11794 11.9807C6.12523 11.9783 6.13247 11.9756 6.13966 11.9727L11.2668 9.88936C11.4077 9.83209 11.5 9.69453 11.5 9.54167V2.25C11.5 2.08455 11.3935 1.94413 11.2456 1.89433L6.1274 0.0225775ZM5.62709 11.069V4.38766L1.24576 2.78539V9.28873L5.62709 11.069ZM6.37285 11.069V4.38766L10.7542 2.78537V9.28873L6.37285 11.069ZM3.69319 1.61762L1.96399 2.25L5.99997 3.72598L7.72917 3.0936L3.69319 1.61762ZM8.82028 2.69458L10.036 2.25L5.99997 0.774024L4.7843 1.2186L8.82028 2.69458Z"
            fill="#414042"
        />
    </svg>
);

export default Shipping;
